import { render, staticRenderFns } from "./NavOverviewItem.vue?vue&type=template&id=0b3830f5&lang=pug"
import script from "./NavOverviewItem.vue?vue&type=script&lang=js"
export * from "./NavOverviewItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports